/**
 * Mutable UI / debug flags (not frozen constants). Game and Test Flask mode update these.
 */
export const runtimeFlags = {
  testFlaskMode: false,
  showPhysicsBodyContour: false,
  showFlaskPhysicsOutline: false,
  /** Dev-only: procedural sky/sea canvas background (`drawSkySeaBackgroundLayer`). */
  drawSkySeaBackground: true,
  /** Dev-only: night star field overlay (no effect when background is off). */
  drawSkyStars: true,
  /** Dev-only: per-frame legacy stars (twinkle + 140× shadowBlur); default uses baked tile. */
  drawSkyStarsLegacy: false,
  /** Dev-only: dashed outlines on layout chrome bands (vertical + horizontal). */
  showLayoutSectionBorders: false,
  /** Dev-only perf dialog: Fall flask Matter walls (red), collect band (orange), mouth-lid (amber). */
  showFallColliderDebug: false,
  /** Dev-only perf dialog: runway + flask particle bursts (spawn, merge, drop). */
  drawParticles: true,
  /** Dev-only perf dialog: floating +N score labels on catch/merge. */
  drawScorePopups: true,
};

/** @returns {boolean} */
export function areRuntimeParticlesEnabled() {
  return runtimeFlags.drawParticles !== false;
}

/** @returns {boolean} */
export function areRuntimeScorePopupsEnabled() {
  return runtimeFlags.drawScorePopups !== false;
}